import { Document, Page, View, StyleSheet, Text, Font } from "@react-pdf/renderer";
import srcRobotoItalic from '../../../assets/custom/font/roboto/Roboto-Italic.ttf';
import srcArialBold from '../../../assets/custom/font/arial/ARIBL0.ttf';
import TransaksiService from "../../../services/transaksi/TransaksiService";
import UserService from "../../../services/user/UserService";
import MasterService from "../../../services/master/MasterService";
import { useCallback, useEffect, useMemo, useState } from "react";
import StatusDok from "../../../utilities/StatusDok";
import JenisKomoditi from "../../../utilities/JenisKomoditi";
import MaksudKegiatan from "../../../utilities/MaksudKegiatan";
import Negara from "../../../utilities/Negara";
import { formatDateStringDateFirst, formatNumber, formatRupiah } from "../../../utilities/Utils";
import CaraAngkut from "../../../utilities/CaraAngkut";
import Kemasan from "../../../utilities/Kemasan";
import JenisDokumen from "../../../utilities/JenisDokumen";
import KontainerUkuran from "../../../utilities/KontainerUkuran";
import KontainerJenis from "../../../utilities/KontainerJenis";
import KontainerTipe from "../../../utilities/KontainerTipe";
import JenisProduk from "../../../utilities/JenisProduk";
import TipeTemp from "../../../utilities/TipeTemp";
import Propinsi from "../../../utilities/Propinsi";
import KotaKab from "../../../utilities/KotaKab";

Font.register({ family: 'Roboto-Italic', src: srcRobotoItalic })
Font.register({ family: 'Arial MT Black', src: srcArialBold })

const styles = StyleSheet.create({
    page: {
        paddingTop: 20,
        paddingBottom: 48,
        paddingHorizontal: 48,
        boxSizing: "border-box"
    },
    headingEn: {
        fontFamily: "Arial MT Black",
        fontSize: 9,
        textAlign: "center",
    },
    textBox: {
        fontSize: 8,
    },
    textBoxInf: {
        fontSize: 8,
        textAlign: "left",
    },
    table: {
        border: '1 solid black',
        display: 'table',
        width: 'auto',
    },
    tableInf0: {
        borderRight: '1 solid black',
        borderTop: '1 solid black',
        borderBottom: '1 solid black',
        display: 'table',
        width: '5%',
    },
    tableInf1: {
        borderTop: '1 solid black',
        borderBottom: '1 solid black',
        display: 'table',
        width: '20%',
    },
    tableInf2: {
        border: '1 solid black',
        display: 'table',
        width: '20%',
    },
    tableInf3: {
        borderTop: '1 solid black',
        borderBottom: '1 solid black',
        display: 'table',
        width: '20%',
    },
    tableInf4: {
        border: '1 solid black',
        display: 'table',
        width: '15%',
    },
    tableInf5: {
        borderTop: '1 solid black',
        borderBottom: '1 solid black',
        display: 'table',
        width: '20%',
    },
    tableCon1: {
        borderBottom: '1 solid black',
        borderRight: '1 solid black',
        display: 'table',
        width: '50%',
    },
    tableCon2: {
        borderBottom: '1 solid black',
        display: 'table',
        width: '50%',
    },
    tableCer1: {
        display: 'table',
        width: '60%',
    },
    tableCer2: {
        display: 'table',
        width: '50%',
    },
    tableCer3: {
        display: 'table',
        width: '100%',
    },
    tableRow: {
        flexDirection: 'row',
    },
    tableRowSign: {
        flexDirection: 'row',
        marginTop: 60
    },
    tableRowSignName: {
        flexDirection: 'row',
        marginTop: 30
    },
    tableCol1: {
        width: '30%',
        padding: 5,
        textAlign: 'left',
    },
    tableCol2: {
        width: '5%',
        padding: 5,
        textAlign: 'left',
    },
    tableCol3: {
        width: '60%',
        padding: 5,
        textAlign: 'left',
    },
    tableColTX1: {
        width: '28%',
        padding: 2,
        textAlign: 'left',
    },
    tableColTX2: {
        width: '25%',
        padding: 2,
        textAlign: 'left',
    },
    tableColTX3: {
        width: '40%',
        padding: 2,
        textAlign: 'left',
    },
    tableBox: {
        width: 'auto',
        display: 'table'
    },
    textEn: {
        fontSize: 8,
        textAlign: "left"
    },
    textIn: {
        fontFamily: "Roboto-Italic",
        fontSize: 8,
        textAlign: "left",
    },
    textEnInf: {
        fontSize: 8,
        textAlign: "center",
    },
    textInInf: {
        fontFamily: "Roboto-Italic",
        fontSize: 8,
        textAlign: "center",
    },
    textEnBold: {
        fontFamily: "Arial MT Black",
        fontSize: 8
    },
    textInCenter: {
        fontFamily: "Roboto-Italic",
        fontSize: 8,
        textAlign: "center",
    },
    tableColBox1: {
        width: '35%',
        padding: 2,
        textAlign: 'left',
    },
    tableColBox2: {
        width: '5%',
        padding: 2,
        textAlign: 'left',
    },
    tableColBox3: {
        width: '55%',
        padding: 5,
        textAlign: 'left',
    },
    tableColBoxCon1: {
        padding: 2,
        textAlign: 'left',
    },
    tableColBoxCon2: {
        padding: 2,
        textAlign: 'left',
    },
    tableColBoxCon3: {
        padding: 2,
        textAlign: 'left',
    },
    tableColBoxInf1: {
        width: '85%',
        borderBottom: '1 solid black',
        textAlign: 'Center',
    },
    tableColBoxInf2: {
        width: '85%',
        padding: 5,
        textAlign: 'Center',
    },
    tableColBoxAtt: {
        width: '85%',
        textAlign: 'left',
    },
    tableColBoxSign1: {
        width: '5%',
        textAlign: 'left',
    },
    tableColBoxSign2: {
        width: '25%',
        textAlign: 'left',
    },
    tableColBoxSign3: {
        width: '30%',
        textAlign: 'left',
    },
    tableColBoxSign5: {
        width: '50%',
        textAlign: 'center',
    },
    tableboxSign: {
        width: 'auto',
        display: 'table',
        marginTop: 15
    }
})

const DraftPermohonan = ({ datappm }) => {

    let transaksiService = useMemo(() => new TransaksiService(), [])
    let userService = useMemo(() => new UserService(), [])
    let masterService = useMemo(() => new MasterService(), [])

    const [upt, setUpt] = useState(null)
    const [pelAsal, setPelAsal] = useState(null)
    const [pelMuat, setPelMuat] = useState(null)
    const [pelBongkar, setPelBongkar] = useState(null)
    const [ppmHeader, setPpmHeader] = useState(null)
    const [ppmDetil, setPpmDetil] = useState([])
    const [ppmDok, setPpmDok] = useState([])
    const [ppmKontainer, setPpmKontainer] = useState([])
    const [ppmMutu, setPpmMutu] = useState({})
    const [ppmMutuArea, setPpmMutuArea] = useState(null)
    const [ppmMutuProd, setPpmMutuProd] = useState([])
    const [ppmKemasan, setPpmKemasan] = useState([])

    const fetchAllData = useCallback(async () => {
        if (!datappm?.nomorAju) {
            console.warn("datappm tidak ada")
            return
        }

        const jsonPelAsal = {
            jnsPelabuhan: "D",
            kodePelabuhan: datappm.pelabuhanAsal
        }

        const jsonPelMuat = {
            jnsPelabuhan: "D",
            kodePelabuhan: datappm.pelabuhanMuat
        }

        const jsonPelLn = {
            jnsPelabuhan: "L",
            kodePelabuhan: datappm.pelabuhanBongkar
        }

        try {
            const results = await Promise.allSettled([
                userService.getUptById(datappm.kdUpt),
                transaksiService.listPpmDetilAll(datappm.nomorAju),
                transaksiService.listPpmKemasanAll(datappm.nomorAju),
                transaksiService.listPpmDokAll(datappm.nomorAju),
                transaksiService.listPpmContainerAll(datappm.nomorAju),
                masterService.getPelabuhanById(JSON.stringify(jsonPelAsal)),
                masterService.getPelabuhanById(JSON.stringify(jsonPelMuat)),
                masterService.getPelabuhanById(JSON.stringify(jsonPelLn)),
                transaksiService.getPpmMutuById(datappm.nomorAju),
                transaksiService.listPpmMutuAreaAll(datappm.nomorAju),
                transaksiService.listPpmMutuProdAll(datappm.nomorAju),
            ])
            const [
                resUpt,
                resDetil,
                resKemasanAll,
                resDokumen,
                resKontainer,
                resPelAsal,
                resPelDn,
                resPelLn,
                resMutu,
                resMutuArea,
                resMutuProd
            ] = results

            const getData = (res, fallback = []) =>
                res.status === "fulfilled"
                    ? res.value?.data?.data ?? res.value?.data ?? fallback
                    : fallback;

            setPpmHeader(datappm)
            setUpt(getData(resUpt, {}));
            setPpmDetil(getData(resDetil));
            setPpmKemasan(getData(resKemasanAll));
            setPpmDok(getData(resDokumen));
            setPpmKontainer(getData(resKontainer));

            setPelAsal(getData(resPelAsal, {}));
            setPelMuat(getData(resPelDn, {}));
            setPelBongkar(getData(resPelLn, {}));

            setPpmMutu(getData(resMutu, {}));
            setPpmMutuArea(getData(resMutuArea));
            setPpmMutuProd(getData(resMutuProd));

        } catch (error) {
            console.error("Gagal memuat data:", error);
        }
    }, [datappm, transaksiService, userService, masterService])

    useEffect(() => {
        let isMounted = true
        if (!datappm) return

        const loadData = async () => {
            try {
                await fetchAllData();
            } catch (e) {
                if (isMounted) console.error(e);
            }
        };

        loadData();

        return () => { isMounted = false; };
    }, [datappm, fetchAllData]);

    return (
        <Document>
            <Page size="A4" style={styles.page}>
                <View>
                    <Text style={styles.headingEn}>PERMOHONAN PENERBITAN SMKHP</Text>
                </View>
                <View>
                    <Text style={styles.headingEn}>NOMOR PENGAJUAN : </Text>
                    <Text style={styles.headingEn}>{ppmHeader ? ppmHeader.nomorAju : ''}</Text>
                </View>
                <View>
                    <Text style={styles.headingEn}>STATUS : </Text>
                    <Text style={styles.headingEn}>{ppmHeader ? (<StatusDok kodeStatus={ppmHeader.status} />) : ''}</Text>
                </View>
                <View style={[styles.table, { paddingTop: 10, border: 0 }]}></View>
                <View style={[styles.table]}>
                    <View style={styles.tableRow}>
                        <View style={styles.tableCon1}>
                            <View style={styles.tableRow}>
                                <View style={styles.tableColBoxCon1}>
                                    <Text style={styles.textEnBold}>DATA PENGAJUAN</Text>
                                </View>
                            </View>
                            <View style={styles.tableRow}>
                                <View style={styles.tableColBoxCon1}>
                                    <Text style={styles.textEn}>Jenis Komoditi : </Text>
                                </View>
                                <View style={styles.tableColBoxCon2}>
                                    <Text style={styles.textIn}>{ppmHeader ? (<JenisKomoditi id={ppmHeader.jenisKomoditi} />) : ''}</Text>
                                </View>
                            </View>
                            <View style={styles.tableRow}>
                                <View style={styles.tableColBoxCon1}>
                                    <Text style={styles.textEn}>Maksud Kegiatan : </Text>
                                </View>
                                <View style={styles.tableColBoxCon2}>
                                    <Text style={styles.textIn}>{ppmHeader ? (<MaksudKegiatan id={ppmHeader.maksudKegiatan} />) : ''}</Text>
                                </View>
                            </View>
                            <View style={styles.tableRow}>
                                <View style={styles.tableColBoxCon1}>
                                    <Text style={styles.textEn}>Peruntukan : </Text>
                                </View>
                                <View style={styles.tableColBoxCon2}>
                                    <Text style={styles.textIn}>{ppmHeader ? (ppmHeader.peruntukan === '1' ? 'Konsumsi' : 'Non Konsumsi') : ''}</Text>
                                </View>
                            </View>
                            <View style={styles.tableRow}>
                                <View style={styles.tableColBoxCon1}>
                                    <Text style={styles.textEn}>UPT : </Text>
                                </View>
                                <View style={styles.tableColBoxCon2}>
                                    <Text style={[styles.textIn, { width: '80%' }]}>{upt ? upt.nmInggris : ''}</Text>
                                </View>
                            </View>
                        </View>
                        <View style={styles.tableCon2}>
                            <View style={styles.tableRow}>
                                <View style={styles.tableColBoxCon1}>
                                    <Text style={styles.textEnBold}>DATA PELABUHAN</Text>
                                </View>
                            </View>
                            <View style={styles.tableRow}>
                                <View style={styles.tableColBoxCon1}>
                                    <Text style={styles.textEn}>Pelabuhan Asal : </Text>
                                </View>
                                <View style={styles.tableColBoxCon2}>
                                    <Text style={styles.textIn}>{ppmHeader ? ppmHeader.pelabuhanAsal : ''} - {pelAsal ? pelAsal.uraianPelabuhan : ''}</Text>
                                </View>
                            </View>
                            <View style={styles.tableRow}>
                                <View style={styles.tableColBoxCon1}>
                                    <Text style={styles.textEn}>Pelabuhan Muat : </Text>
                                </View>
                                <View style={styles.tableColBoxCon2}>
                                    <Text style={styles.textIn}>{ppmHeader ? ppmHeader.pelabuhanMuat : ''} - {pelMuat ? pelMuat.uraianPelabuhan : ''}</Text>
                                </View>
                            </View>
                            <View style={styles.tableRow}>
                                <View style={styles.tableColBoxCon1}>
                                    <Text style={styles.textEn}>Pelabuhan Bongkar : </Text>
                                </View>
                                <View style={styles.tableColBoxCon2}>
                                    <Text style={styles.textIn}>{ppmHeader ? ppmHeader.pelabuhanBongkar : ''} - {pelBongkar ? pelBongkar.uraianPelabuhan : ''}</Text>
                                </View>
                            </View>
                        </View>
                    </View>
                    <View style={styles.tableRow}>
                        <View style={styles.tableCon1}>
                            <View style={styles.tableRow}>
                                <View style={styles.tableColBoxCon1}>
                                    <Text style={styles.textEnBold}>PEMILIK BARANG</Text>
                                </View>
                            </View>
                            <View style={styles.tableRow}>
                                <View style={styles.tableColBoxCon1}>
                                    <Text style={styles.textEn}>NPWP : </Text>
                                </View>
                                <View style={styles.tableColBoxCon2}>
                                    <Text style={styles.textIn}>{ppmHeader ? ppmHeader.npwpTrader : ''}</Text>
                                </View>
                            </View>
                            <View style={styles.tableRow}>
                                <View style={styles.tableColBoxCon2}>
                                    <Text style={styles.textEn}>Nama : </Text>
                                </View>
                                <View style={styles.tableColBoxCon2}>
                                    <Text style={styles.textIn}>{ppmHeader ? ppmHeader.namaTrader : ''}</Text>
                                </View>
                            </View>
                            <View style={styles.tableRow}>
                                <View style={styles.tableColBoxCon1}>
                                    <Text style={styles.textEn}>Alamat : </Text>
                                </View>
                                <View style={styles.tableColBoxCon2}>
                                    <Text style={styles.textIn}>{ppmHeader ? ppmHeader.alamatTrader : ''}</Text>
                                </View>
                            </View>
                            <View style={styles.tableRow}>
                                <View style={styles.tableColBoxCon2}>
                                    <Text style={styles.textEn}>Kode Pos : </Text>
                                </View>
                                <View style={styles.tableColBoxCon2}>
                                    <Text style={styles.textIn}>{ppmHeader ? ppmHeader.kodeposTrader : ''}</Text>
                                </View>
                            </View>
                        </View>
                        <View style={styles.tableCon2}>
                            <View style={styles.tableRow}>
                                <View style={styles.tableColBoxCon1}>
                                    <Text style={styles.textEnBold}>DATA SARANA ANGKUT</Text>
                                </View>
                            </View>
                            <View style={styles.tableRow}>
                                <View style={styles.tableColBoxCon1}>
                                    <Text style={styles.textEn}>Cara Angkut : </Text>
                                </View>
                                <View style={styles.tableColBoxCon2}>
                                    <Text style={styles.textIn}>{ppmHeader ? <CaraAngkut id={ppmHeader.moda} /> : ''}</Text>
                                </View>
                            </View>
                            <View style={styles.tableRow}>
                                <View style={styles.tableColBoxCon1}>
                                    <Text style={styles.textEn}>Nama Angkut : </Text>
                                </View>
                                <View style={styles.tableColBoxCon2}>
                                    <Text style={styles.textIn}>{ppmHeader ? ppmHeader.angkut : ''}</Text>
                                </View>
                            </View>
                            <View style={styles.tableRow}>
                                <View style={styles.tableColBoxCon1}>
                                    <Text style={styles.textEn}>Nomor Voy/Flight : </Text>
                                </View>
                                <View style={styles.tableColBoxCon2}>
                                    <Text style={styles.textIn}>{ppmHeader ? ppmHeader.voyage : ''}</Text>
                                </View>
                            </View>
                            <View style={styles.tableRow}>
                                <View style={styles.tableColBoxCon1}>
                                    <Text style={styles.textEn}>Bendera : </Text>
                                </View>
                                <View style={styles.tableColBoxCon2}>
                                    <Text style={styles.textIn}>{ppmHeader ? (<Negara id={ppmHeader.bendera} />) : ''}</Text>
                                </View>
                            </View>
                            <View style={styles.tableRow}>
                                <View style={styles.tableColBoxCon1}>
                                    <Text style={styles.textEn}>Tanggal Ekspor : </Text>
                                </View>
                                <View style={styles.tableColBoxCon2}>
                                    <Text style={styles.textIn}>{ppmHeader ? formatDateStringDateFirst(ppmHeader.tanggalTibaBerangkat) : ''}</Text>
                                </View>
                            </View>
                        </View>
                    </View>
                    <View style={styles.tableRow}>
                        <View style={styles.tableCon1}>
                            <View style={styles.tableRow}>
                                <View style={styles.tableColBoxCon1}>
                                    <Text style={styles.textEnBold}>DATA PENERIMA</Text>
                                </View>
                            </View>
                            <View style={styles.tableRow}>
                                <View style={styles.tableColBoxCon1}>
                                    <Text style={styles.textEn}>Nama : </Text>
                                </View>
                                <View style={styles.tableColBoxCon2}>
                                    <Text style={styles.textIn}>{ppmHeader ? ppmHeader.namaPartner : ''}</Text>
                                </View>
                            </View>
                            <View style={styles.tableRow}>
                                <View style={styles.tableColBoxCon1}>
                                    <Text style={styles.textEn}>Alamat : </Text>
                                </View>
                                <View style={styles.tableColBoxCon2}>
                                    <Text style={[styles.textIn, { width: '80%' }]}>{ppmHeader ? ppmHeader.alamatPartner : ''}</Text>
                                </View>
                            </View>
                            <View style={styles.tableRow}>
                                <View style={styles.tableColBoxCon1}>
                                    <Text style={styles.textEn}>Negara Partner : </Text>
                                </View>
                                <View style={styles.tableColBoxCon2}>
                                    <Text style={styles.textIn}>{ppmHeader ? (<Negara id={ppmHeader.negaraPartner} />) : ''}</Text>
                                </View>
                            </View>
                        </View>
                        <View style={styles.tableCon2}>
                            <View style={styles.tableRow}>
                                <View style={styles.tableColBoxCon1}>
                                    <Text style={styles.textEnBold}>INFORMASI LAIN</Text>
                                </View>
                            </View>
                            <View style={styles.tableRow}>
                                <View style={styles.tableColBoxCon1}>
                                    <Text style={styles.textEn}>Nilai Ekspor (Rp.) : </Text>
                                </View>
                                <View style={styles.tableColBoxCon2}>
                                    <Text style={styles.textIn}>{ppmHeader ? formatRupiah(ppmHeader.nilai) : ''}</Text>
                                </View>
                            </View>
                            <View style={styles.tableRow}>
                                <View style={styles.tableColBoxCon1}>
                                    <Text style={styles.textEn}>Bruto (Kg) : </Text>
                                </View>
                                <View style={styles.tableColBoxCon2}>
                                    <Text style={styles.textIn}>{ppmHeader ? formatNumber(ppmHeader.bruto) : ''}</Text>
                                </View>
                            </View>
                            <View style={styles.tableRow}>
                                <View style={styles.tableColBoxCon1}>
                                    <Text style={styles.textEn}>Netto : </Text>
                                </View>
                                <View style={styles.tableColBoxCon2}>
                                    <Text style={styles.textIn}>{ppmHeader ? formatNumber(ppmHeader.netto) : ''}</Text>
                                </View>
                            </View>
                        </View>
                    </View>
                    <View style={styles.tableRow}>
                        <View style={styles.tableCon1}>
                            <View style={styles.tableRow}>
                                <View style={styles.tableColBoxCon1}>
                                    <Text style={styles.textEnBold}>DATA PENANGGUNG JAWAB</Text>
                                </View>
                            </View>
                            <View style={styles.tableRow}>
                                <View style={styles.tableColBoxCon1}>
                                    <Text style={styles.textEn}>Nama : </Text>
                                </View>
                                <View style={styles.tableColBoxCon2}>
                                    <Text style={styles.textIn}>{ppmHeader ? ppmHeader.namaCp : ''}</Text>
                                </View>
                            </View>
                            <View style={styles.tableRow}>
                                <View style={styles.tableColBoxCon1}>
                                    <Text style={styles.textEn}>Alamat : </Text>
                                </View>
                                <View style={styles.tableColBoxCon2}>
                                    <Text style={styles.textIn}>{ppmHeader ? ppmHeader.alamatCp : ''}</Text>
                                </View>
                            </View>
                            <View style={styles.tableRow}>
                                <View style={styles.tableColBoxCon1}>
                                    <Text style={styles.textEn}>No. Telepon : </Text>
                                </View>
                                <View style={styles.tableColBoxCon2}>
                                    <Text style={styles.textIn}>{ppmHeader ? ppmHeader.teleponCp : ''}</Text>
                                </View>
                            </View>
                        </View>
                        <View style={styles.tableCon2}>
                            <View style={styles.tableRow}>
                                <View style={styles.tableColBoxCon1}>
                                    <Text style={styles.textEnBold}>DATA PENANDATANGAN PERMOHONAN</Text>
                                </View>
                            </View>
                            <View style={styles.tableRow}>
                                <View style={styles.tableColBoxCon1}>
                                    <Text style={styles.textEn}>Nama TTD : </Text>
                                </View>
                                <View style={styles.tableColBoxCon2}>
                                    <Text style={styles.textIn}>{ppmHeader ? ppmHeader.namaTtd : ''}</Text>
                                </View>
                            </View>
                            <View style={styles.tableRow}>
                                <View style={styles.tableColBoxCon1}>
                                    <Text style={styles.textEn}>Jabatan : </Text>
                                </View>
                                <View style={styles.tableColBoxCon2}>
                                    <Text style={styles.textIn}>{ppmHeader ? ppmHeader.jabatanTtd : ''}</Text>
                                </View>
                            </View>
                            <View style={styles.tableRow}>
                                <View style={styles.tableColBoxCon1}>
                                    <Text style={styles.textEn}>Tempat TTD : </Text>
                                </View>
                                <View style={styles.tableColBoxCon2}>
                                    <Text style={styles.textIn}>{ppmHeader ? ppmHeader.tempatTtd : ''}</Text>
                                </View>
                            </View>
                            <View style={styles.tableRow}>
                                <View style={styles.tableColBoxCon1}>
                                    <Text style={styles.textEn}>Tanggal TTD : </Text>
                                </View>
                                <View style={styles.tableColBoxCon2}>
                                    <Text style={styles.textIn}>{ppmHeader ? formatDateStringDateFirst(ppmHeader.tanggalTtd) : ''}</Text>
                                </View>
                            </View>
                        </View>
                    </View>
                    <View style={styles.tableCer3}>
                        <View style={styles.tableRow}>
                            <View style={styles.tableColBoxCon1}>
                                <Text style={styles.textEnBold}>DETAIL BARANG</Text>
                            </View>
                        </View>
                        <View style={[styles.tableRow, { borderTop: 1, borderBottom: 1 }]}>
                            <View style={[styles.tableCol, { width: "15%", borderRightWidth: 1 }]}>
                                <Text style={styles.textEnInf}>KODE HS</Text>
                            </View>
                            <View style={[styles.tableCol, { width: "23%", borderRightWidth: 1 }]}>
                                <Text style={styles.textEnInf}>Uraian Barang</Text>
                            </View>
                            <View style={[styles.tableCol, { width: "23%", borderRightWidth: 1 }]}>
                                <Text style={styles.textEnInf}>Nama Latin</Text>
                            </View>
                            <View style={[styles.tableCol, { width: "15%", borderRightWidth: 1 }]}>
                                <Text style={styles.textEnInf}>Volume</Text>
                            </View>
                            <View style={[styles.tableCol, { width: "10%", borderRightWidth: 1 }]}>
                                <Text style={styles.textEnInf}>Satuan</Text>
                            </View>
                            <View style={[styles.tableCol, { width: "15%", borderRightWidth: 1 }]}>
                                <Text style={styles.textEnInf}>Netto</Text>
                            </View>
                            <View style={[styles.tableCol, { width: "15%", borderRightWidth: 1 }]}>
                                <Text style={styles.textEnInf}>Nilai (Rp.)</Text>
                            </View>
                            <View style={[styles.tableCol, { width: "15%" }]}>
                                <Text style={styles.textEnInf}>Keterangan</Text>
                            </View>
                        </View>
                        {
                            ppmDetil ?
                                (
                                    ppmDetil.map((dtl, index) => {
                                        return <>
                                            <View key={dtl.trPpkDtlPK.seri} style={[styles.tableRow, { borderTopWidth: 1, borderBottom: 1 }]}>
                                                <View style={[styles.tableCol, { width: "15%", borderRightWidth: 1 }]}>
                                                    <Text style={[styles.textEnInf]}>{dtl.kodeHs}</Text>
                                                </View>
                                                <View style={[styles.tableCol, { width: "23%", borderRightWidth: 1 }]}>
                                                    <Text style={[styles.textEnInf]}>{dtl.namaLokal}</Text>
                                                </View>
                                                <View style={[styles.tableCol, { width: "23%", borderRightWidth: 1 }]}>
                                                    <Text style={[styles.textInInf]}>{dtl.namaLatin}</Text>
                                                </View>
                                                <View style={[styles.tableCol, { width: "15%", borderRightWidth: 1 }]}>
                                                    <Text style={[styles.textEnInf]}>{formatNumber(dtl.jumlah)}</Text>
                                                </View>
                                                <View style={[styles.tableCol, { width: "10%", borderRightWidth: 1 }]}>
                                                    <Text style={[styles.textEnInf]}>{dtl.kodeSatuan}</Text>
                                                </View>
                                                <View style={[styles.tableCol, { width: "15%", borderRightWidth: 1 }]}>
                                                    <Text style={[styles.textEnInf]}>{formatNumber(dtl.netto)}</Text>
                                                </View>
                                                <View style={[styles.tableCol, { width: "15%", borderRightWidth: 1 }]}>
                                                    <Text style={[styles.textEnInf]}>{formatRupiah(dtl.nilai)}</Text>
                                                </View>
                                                <View style={[styles.tableCol, { width: "15%" }]}>
                                                    <Text style={[styles.textEnInf]}></Text>
                                                </View>
                                            </View>
                                        </>
                                    })
                                ) :
                                (
                                    <>
                                        <View style={[styles.tableRow, { borderTopWidth: 1, borderBottom: 1 }]}>
                                            <View style={[styles.tableCol, { width: "15%", borderRightWidth: 1 }]}>
                                                <Text style={[styles.textEnInf]}></Text>
                                            </View>
                                            <View style={[styles.tableCol, { width: "23%", borderRightWidth: 1 }]}>
                                                <Text style={[styles.textEnInf]}></Text>
                                            </View>
                                            <View style={[styles.tableCol, { width: "23%", borderRightWidth: 1 }]}>
                                                <Text style={[styles.textInInf]}></Text>
                                            </View>
                                            <View style={[styles.tableCol, { width: "15%", borderRightWidth: 1 }]}>
                                                <Text style={[styles.textEnInf]}></Text>
                                            </View>
                                            <View style={[styles.tableCol, { width: "10%", borderRightWidth: 1 }]}>
                                                <Text style={[styles.textEnInf]}></Text>
                                            </View>
                                            <View style={[styles.tableCol, { width: "15%", borderRightWidth: 1 }]}>
                                                <Text style={[styles.textEnInf]}></Text>
                                            </View>
                                            <View style={[styles.tableCol, { width: "15%", borderRightWidth: 1 }]}>
                                                <Text style={[styles.textEnInf]}></Text>
                                            </View>
                                            <View style={[styles.tableCol, { width: "15%" }]}>
                                                <Text style={[styles.textEnInf]}></Text>
                                            </View>
                                        </View>
                                    </>
                                )
                        }
                    </View>
                    <View style={styles.tableCer3}>
                        <View style={styles.tableRow}>
                            <View style={styles.tableColBoxCon1}>
                                <Text style={styles.textEnBold}>DETAIL KEMASAN</Text>
                            </View>
                        </View>
                        <View style={[styles.tableRow, { borderTop: 1, borderBottom: 1 }]}>
                            <View style={[styles.tableCol, { width: "45%", borderRightWidth: 1 }]}>
                                <Text style={styles.textEnInf}>Jenis Kemasan</Text>
                            </View>
                            <View style={[styles.tableCol, { width: "33%", borderRightWidth: 1 }]}>
                                <Text style={styles.textEnInf}>Merk</Text>
                            </View>
                            <View style={[styles.tableCol, { width: "32%" }]}>
                                <Text style={styles.textEnInf}>Jumlah</Text>
                            </View>
                        </View>
                        {
                            ppmKemasan ?
                                (
                                    ppmKemasan.map((kms, index) => {
                                        return <>
                                            <View key={kms.trPpkKemasanPK.seri} style={[styles.tableRow, { borderTopWidth: 1, borderBottom: 1 }]}>
                                                <View style={[styles.tableCol, { width: "45%", borderRightWidth: 1 }]}>
                                                    <Text style={[styles.textEnInf]}><Kemasan id={kms.kodeKemasan} /></Text>
                                                </View>
                                                <View style={[styles.tableCol, { width: "33%", borderRightWidth: 1 }]}>
                                                    <Text style={[styles.textEnInf]}>{kms.merk}</Text>
                                                </View>
                                                <View style={[styles.tableCol, { width: "32%" }]}>
                                                    <Text style={[styles.textInInf]}>{kms.jumlah}</Text>
                                                </View>
                                            </View>
                                        </>
                                    })
                                ) :
                                (
                                    <>
                                        <View style={[styles.tableRow, { borderTopWidth: 1, borderBottom: 1 }]}>
                                            <View style={[styles.tableCol, { width: "45%", borderRightWidth: 1 }]}>
                                                <Text style={[styles.textEnInf]}></Text>
                                            </View>
                                            <View style={[styles.tableCol, { width: "33%", borderRightWidth: 1 }]}>
                                                <Text style={[styles.textEnInf]}></Text>
                                            </View>
                                            <View style={[styles.tableCol, { width: "32%" }]}>
                                                <Text style={[styles.textInInf]}></Text>
                                            </View>
                                        </View>
                                    </>
                                )
                        }

                    </View>
                    <View style={styles.tableCer3}>
                        <View style={styles.tableRow}>
                            <View style={styles.tableColBoxCon1}>
                                <Text style={styles.textEnBold}>DETAIL DOKUMEN</Text>
                            </View>
                        </View>
                        <View style={[styles.tableRow, { borderTop: 1, borderBottom: 1 }]}>
                            <View style={[styles.tableCol, { width: "45%", borderRightWidth: 1 }]}>
                                <Text style={styles.textEnInf}>Kode Dokumen</Text>
                            </View>
                            <View style={[styles.tableCol, { width: "23%", borderRightWidth: 1 }]}>
                                <Text style={styles.textEnInf}>Nomor Dokumen</Text>
                            </View>
                            <View style={[styles.tableCol, { width: "15%", borderRightWidth: 1 }]}>
                                <Text style={styles.textEnInf}>Tanggal</Text>
                            </View>
                            <View style={[styles.tableCol, { width: "17%" }]}>
                                <Text style={styles.textEnInf}>Negara</Text>
                            </View>
                        </View>
                        {
                            ppmDok ?
                                (
                                    ppmDok.map((dok, index) => {
                                        return <>
                                            <View key={dok.trPpkDokPK.seri} style={[styles.tableRow, { borderTopWidth: 1, borderBottom: 1 }]}>
                                                <View style={[styles.tableCol, { width: "45%", borderRightWidth: 1 }]}>
                                                    <Text style={[styles.textEnInf]}><JenisDokumen id={dok.kodeDokumen} /></Text>
                                                </View>
                                                <View style={[styles.tableCol, { width: "23%", borderRightWidth: 1 }]}>
                                                    <Text style={[styles.textEnInf]}>{dok.nomor}</Text>
                                                </View>
                                                <View style={[styles.tableCol, { width: "15%", borderRightWidth: 1 }]}>
                                                    <Text style={[styles.textInInf]}>{formatDateStringDateFirst(dok.tanggal)}</Text>
                                                </View>
                                                <View style={[styles.tableCol, { width: "17%" }]}>
                                                    <Text style={[styles.textInInf]}><Negara id={dok.negara} /></Text>
                                                </View>
                                            </View>
                                        </>
                                    })
                                ) :
                                (
                                    <View style={[styles.tableRow, { borderTopWidth: 1, borderBottom: 1 }]}>
                                        <View style={[styles.tableCol, { width: "45%", borderRightWidth: 1 }]}>
                                            <Text style={[styles.textEnInf]}></Text>
                                        </View>
                                        <View style={[styles.tableCol, { width: "23%", borderRightWidth: 1 }]}>
                                            <Text style={[styles.textEnInf]}></Text>
                                        </View>
                                        <View style={[styles.tableCol, { width: "15%", borderRightWidth: 1 }]}>
                                            <Text style={[styles.textInInf]}></Text>
                                        </View>
                                        <View style={[styles.tableCol, { width: "17%" }]}>
                                            <Text style={[styles.textInInf]}></Text>
                                        </View>
                                    </View>
                                )
                        }

                    </View>
                    <View style={[styles.tableCer3, { borderBottom: 0 }]}>
                        <View style={styles.tableRow}>
                            <View style={styles.tableColBoxCon1}>
                                <Text style={styles.textEnBold}>DETAIL CONTAINER</Text>
                            </View>
                        </View>
                        <View style={[styles.tableRow, { borderTop: 1, borderBottom: 1 }]}>
                            <View style={[styles.tableCol, { width: "20%", borderRightWidth: 1 }]}>
                                <Text style={styles.textEnInf}>No Container</Text>
                            </View>
                            <View style={[styles.tableCol, { width: "20%", borderRightWidth: 1 }]}>
                                <Text style={styles.textEnInf}>Ukuran</Text>
                            </View>
                            <View style={[styles.tableCol, { width: "20%", borderRightWidth: 1 }]}>
                                <Text style={styles.textEnInf}>Jenis Stuff</Text>
                            </View>
                            <View style={[styles.tableCol, { width: "20%", borderRightWidth: 1 }]}>
                                <Text style={styles.textEnInf}>Tipe</Text>
                            </View>
                            <View style={[styles.tableCol, { width: "20%" }]}>
                                <Text style={styles.textEnInf}>No Segel</Text>
                            </View>
                        </View>
                        {
                            ppmKontainer ?
                                (
                                    ppmKontainer.map((kont, index) => {
                                        return <>
                                            <View key={kont.trPpkContainerPK.seri} style={[styles.tableRow, { borderTopWidth: 1, borderBottom: 1 }]}>
                                                <View style={[styles.tableCol, { width: "20%", borderRightWidth: 1 }]}>
                                                    <Text style={[styles.textEnInf]}>{kont.nomor}</Text>
                                                </View>
                                                <View style={[styles.tableCol, { width: "20%", borderRightWidth: 1 }]}>
                                                    <Text style={[styles.textEnInf]}><KontainerUkuran id={kont.ukuran} /></Text>
                                                </View>
                                                <View style={[styles.tableCol, { width: "20%", borderRightWidth: 1 }]}>
                                                    <Text style={[styles.textInInf]}><KontainerJenis id={kont.jenisStuff} /></Text>
                                                </View>
                                                <View style={[styles.tableCol, { width: "20%", borderRightWidth: 1 }]}>
                                                    <Text style={[styles.textInInf]}><KontainerTipe id={kont.tipe} /></Text>
                                                </View>
                                                <View style={[styles.tableCol, { width: "20%" }]}>
                                                    <Text style={[styles.textInInf]}>{kont.nomorSegel}</Text>
                                                </View>
                                            </View>
                                        </>
                                    })
                                )
                                :
                                (
                                    <>
                                        <View style={[styles.tableRow, { borderTopWidth: 1, borderBottom: 1 }]}>
                                            <View style={[styles.tableCol, { width: "20%", borderRightWidth: 1 }]}>
                                                <Text style={[styles.textEnInf]}></Text>
                                            </View>
                                            <View style={[styles.tableCol, { width: "20%", borderRightWidth: 1 }]}>
                                                <Text style={[styles.textEnInf]}></Text>
                                            </View>
                                            <View style={[styles.tableCol, { width: "20%", borderRightWidth: 1 }]}>
                                                <Text style={[styles.textInInf]}></Text>
                                            </View>
                                            <View style={[styles.tableCol, { width: "20%", borderRightWidth: 1 }]}>
                                                <Text style={[styles.textInInf]}></Text>
                                            </View>
                                            <View style={[styles.tableCol, { width: "20%" }]}>
                                                <Text style={[styles.textInInf]}></Text>
                                            </View>
                                        </View>
                                    </>
                                )
                        }
                    </View>
                </View >
            </Page >
            <Page size="A4" style={styles.page}>
                <View>
                    <Text style={styles.headingEn}>PERMOHONAN PENERBITAN SMKHP</Text>
                </View>
                <View>
                    <Text style={styles.headingEn}>NOMOR PENGAJUAN : </Text>
                    <Text style={styles.headingEn}>{ppmHeader ? ppmHeader.nomorAju : ''}</Text>
                </View>
                <View>
                    <Text style={styles.headingEn}>STATUS : </Text>
                    <Text style={styles.headingEn}>{ppmHeader ? <StatusDok kodeStatus={ppmHeader.status} /> : ''}</Text>
                </View>
                <View style={[styles.table, { paddingTop: 10, border: 0 }]}></View>
                <View style={[styles.table]}>
                    <View style={styles.tableCol}>
                        <View style={styles.tableColBoxCon1}>
                            <Text style={styles.textEnBold}>DETAIL MUTU</Text>
                        </View>
                    </View>
                    <View style={styles.tableRow}>
                        <View style={styles.tableColBox1}>
                            <Text style={styles.textEn}>NO Reg / License</Text>
                        </View>
                        <View style={styles.tableColBox2}>
                            <Text style={styles.textBox}>:</Text>
                        </View>
                        <View style={styles.tableCol3}>
                            <Text style={styles.textBox}>{ppmMutu ? ppmMutu.upiRegNo : ''}</Text>
                        </View>
                    </View>
                    <View style={styles.tableRow}>
                        <View style={styles.tableColBox1}>
                            <Text style={styles.textEn}>Nama UPI</Text>
                        </View>
                        <View style={styles.tableColBox2}>
                            <Text style={styles.textBox}>:</Text>
                        </View>
                        <View style={styles.tableCol3}>
                            <Text style={styles.textBox}>{ppmMutu ? ppmMutu.upiNama : ''}</Text>
                        </View>
                    </View>
                    <View style={styles.tableRow}>
                        <View style={styles.tableColBox1}>
                            <Text style={styles.textEn}>Alamat UPI</Text>
                        </View>
                        <View style={styles.tableColBox2}>
                            <Text style={styles.textBox}>:</Text>
                        </View>
                        <View style={styles.tableCol3}>
                            <Text style={styles.textBox}>{ppmMutu ? ppmMutu.upiAlamat : ''}</Text>
                        </View>
                    </View>
                    <View style={styles.tableRow}>
                        <View style={styles.tableColBox1}>
                            <Text style={styles.textEn}>Telp. UPI</Text>
                        </View>
                        <View style={styles.tableColBox2}>
                            <Text style={styles.textBox}>:</Text>
                        </View>
                        <View style={styles.tableCol3}>
                            <Text style={styles.textBox}>{ppmMutu ? ppmMutu.upiTelp : ''}</Text>
                        </View>
                    </View>
                    <View style={styles.tableRow}>
                        <View style={styles.tableColBox1}>
                            <Text style={styles.textEn}>No. Registrasi UE UPI</Text>
                        </View>
                        <View style={styles.tableColBox2}>
                            <Text style={styles.textBox}>:</Text>
                        </View>
                        <View style={styles.tableCol3}>
                            <Text style={styles.textBox}>{ppmMutu ? ppmMutu.upiNoRegUe : ''}</Text>
                        </View>
                    </View>
                    <View style={styles.tableRow}>
                        <View style={styles.tableColBox1}>
                            <Text style={styles.textEn}>Negara UPI</Text>
                        </View>
                        <View style={styles.tableColBox2}>
                            <Text style={styles.textBox}>:</Text>
                        </View>
                        <View style={styles.tableCol3}>
                            <Text style={styles.textBox}>Indonesia</Text>
                        </View>
                    </View>
                    <View style={styles.tableRow}>
                        <View style={styles.tableColBox1}>
                            <Text style={styles.textEn}>Negara Asal Produk</Text>
                        </View>
                        <View style={styles.tableColBox2}>
                            <Text style={styles.textBox}>:</Text>
                        </View>
                        <View style={styles.tableCol3}>
                            <Text style={styles.textBox}>Indonesia</Text>
                        </View>
                    </View>
                    <View style={styles.tableRow}>
                        <View style={styles.tableColBox1}>
                            <Text style={styles.textEn}>Deskripsi Produk</Text>
                        </View>
                        <View style={styles.tableColBox2}>
                            <Text style={styles.textBox}>:</Text>
                        </View>
                        <View style={styles.tableCol3}>
                            <Text style={styles.textBox}>{ppmMutu ? ppmMutu.mutuDesk : ''}</Text>
                        </View>
                    </View>
                    <View style={styles.tableRow}>
                        <View style={styles.tableColBox1}>
                            <Text style={styles.textEn}>Additional Information</Text>
                        </View>
                        <View style={styles.tableColBox2}>
                            <Text style={styles.textBox}>:</Text>
                        </View>
                        <View style={styles.tableCol3}>
                            <Text style={styles.textBox}>{ppmMutu ? ppmMutu.addInfo : ''}</Text>
                        </View>
                    </View>
                    <View style={[styles.tableCer3, { borderLeft: 1 }]}>
                        <View style={[styles.tableRow, { borderTop: 1, borderBottom: 1 }]}>
                            <View style={[styles.tableCol, { width: "50%", borderRightWidth: 1 }]}>
                                <Text style={[styles.textEnBold, { textAlign: 'center' }]}>Kode Produksi</Text>
                            </View>
                            <View style={[styles.tableCol, { width: "50%", borderRightWidth: 1 }]}>
                                <Text style={[styles.textEnBold, { textAlign: 'center' }]}>Tanggal Produksi</Text>
                            </View>
                        </View>
                        {
                            ppmMutuProd ?
                                (
                                    ppmMutuProd.map((prod, index) => {
                                        return <>
                                            <View style={[styles.tableRow, { borderTopWidth: 1, borderBottom: 1 }]}>
                                                <View style={[styles.tableCol, { width: "50%", borderRightWidth: 1 }]}>
                                                    <Text style={[styles.textEnInf]}>{prod.mutuProdNo}</Text>
                                                </View>
                                                <View style={[styles.tableCol, { width: "50%", borderRightWidth: 1 }]}>
                                                    <Text style={[styles.textEnInf]}>{formatDateStringDateFirst(prod.mutuProdTgl)}</Text>
                                                </View>
                                            </View>
                                        </>
                                    })
                                )
                                :
                                (
                                    <>
                                        <View style={[styles.tableRow, { borderTopWidth: 1, borderBottom: 1 }]}>
                                            <View style={[styles.tableCol, { width: "50%", borderRightWidth: 1 }]}>
                                                <Text style={[styles.textEnInf]}></Text>
                                            </View>
                                            <View style={[styles.tableCol, { width: "50%", borderRightWidth: 1 }]}>
                                                <Text style={[styles.textEnInf]}></Text>
                                            </View>
                                        </View>
                                    </>
                                )
                        }
                    </View>
                    <View style={[styles.tableCer3, { borderLeft: 1 }]}>
                        <View style={[styles.tableRow, { borderTop: 1, borderBottom: 1 }]}>
                            <View style={[styles.tableCol, { width: "10%", borderRightWidth: 1 }]}>
                                <Text style={[styles.textEnBold, { textAlign: 'center' }]}>Sumber</Text>
                            </View>
                            <View style={[styles.tableCol, { width: "15%", borderRightWidth: 1 }]}>
                                <Text style={[styles.textEnBold, { textAlign: 'center' }]}>Propinsi</Text>
                            </View>
                            <View style={[styles.tableCol, { width: "20%", borderRightWidth: 1 }]}>
                                <Text style={[styles.textEnBold, { textAlign: 'center' }]}>Kabupaten / Kota</Text>
                            </View>
                            <View style={[styles.tableCol, { width: "15%", borderRightWidth: 1 }]}>
                                <Text style={[styles.textEnBold, { textAlign: 'center' }]}>Nama Pembudidaya</Text>
                            </View>
                            <View style={[styles.tableCol, { width: "10%", borderRightWidth: 1 }]}>
                                <Text style={[styles.textEnBold, { textAlign: 'center' }]}>WPP</Text>
                            </View>
                            <View style={[styles.tableCol, { width: "15%", borderRightWidth: 1 }]}>
                                <Text style={[styles.textEnBold, { textAlign: 'center' }]}>Nama Kapal</Text>
                            </View>
                            <View style={[styles.tableCol, { width: "15%", borderRightWidth: 1 }]}>
                                <Text style={[styles.textEnBold, { textAlign: 'center' }]}>Nomor Sertifikat</Text>
                            </View>
                        </View>
                        {
                            ppmMutuArea ?
                                (
                                    ppmMutuArea.map((area, index) => {
                                        return <>
                                            <View key={index} style={[styles.tableRow, { borderTop: 1, borderBottom: 1 }]}>
                                                <View style={[styles.tableCol, { width: "10%", borderRightWidth: 1 }]}>
                                                    <Text style={[styles.textEnInf, { textAlign: 'center' }]}>{area.mutuArea === '1' ? 'Budidaya' : 'Tangkap'}</Text>
                                                </View>
                                                <View style={[styles.tableCol, { width: "15%", borderRightWidth: 1 }]}>
                                                    <Text style={[styles.textEnInf, { textAlign: 'center' }]}>{area.mutuCultProp !== null ? <Propinsi id={area.mutuCultProp} /> : ''}</Text>
                                                </View>
                                                <View style={[styles.tableCol, { width: "20%", borderRightWidth: 1 }]}>
                                                    <Text style={[styles.textEnInf, { textAlign: 'center' }]}>{area.mutuCultKota !== null ? <KotaKab id={area.mutuCultKota} /> : ''}</Text>
                                                </View>
                                                <View style={[styles.tableCol, { width: "15%", borderRightWidth: 1 }]}>
                                                    <Text style={[styles.textEnInf, { textAlign: 'center' }]}>{area.mutuBudidayaNama}</Text>
                                                </View>
                                                <View style={[styles.tableCol, { width: "10%", borderRightWidth: 1 }]}>
                                                    <Text style={[styles.textEnInf, { textAlign: 'center' }]}>{area.mutuTangkapArea}</Text>
                                                </View>
                                                <View style={[styles.tableCol, { width: "15%", borderRightWidth: 1 }]}>
                                                    <Text style={[styles.textEnInf, { textAlign: 'center' }]}>{area.mutuTangkapKapal}</Text>
                                                </View>
                                                <View style={[styles.tableCol, { width: "15%", borderRightWidth: 1 }]}>
                                                    <Text style={[styles.textEnInf, { textAlign: 'center' }]}>{area.mutuNomorSertifikat}</Text>
                                                </View>
                                            </View>
                                        </>
                                    })
                                )
                                :
                                (
                                    <>
                                        <View style={[styles.tableRow, { borderTop: 1, borderBottom: 1 }]}>
                                            <View style={[styles.tableCol, { width: "10%", borderRightWidth: 1 }]}>
                                                <Text style={[styles.textEnBold, { textAlign: 'center' }]}></Text>
                                            </View>
                                            <View style={[styles.tableCol, { width: "15%", borderRightWidth: 1 }]}>
                                                <Text style={[styles.textEnBold, { textAlign: 'center' }]}></Text>
                                            </View>
                                            <View style={[styles.tableCol, { width: "20%", borderRightWidth: 1 }]}>
                                                <Text style={[styles.textEnBold, { textAlign: 'center' }]}></Text>
                                            </View>
                                            <View style={[styles.tableCol, { width: "15%", borderRightWidth: 1 }]}>
                                                <Text style={[styles.textEnBold, { textAlign: 'center' }]}></Text>
                                            </View>
                                            <View style={[styles.tableCol, { width: "10%", borderRightWidth: 1 }]}>
                                                <Text style={[styles.textEnBold, { textAlign: 'center' }]}></Text>
                                            </View>
                                            <View style={[styles.tableCol, { width: "15%", borderRightWidth: 1 }]}>
                                                <Text style={[styles.textEnBold, { textAlign: 'center' }]}></Text>
                                            </View>
                                            <View style={[styles.tableCol, { width: "15%", borderRightWidth: 1 }]}>
                                                <Text style={[styles.textEnBold, { textAlign: 'center' }]}></Text>
                                            </View>
                                        </View>
                                    </>
                                )
                        }
                    </View>
                    <View style={styles.tableRow}>
                        <View style={styles.tableColBox1}>
                            <Text style={styles.textEn}>Gudang Cold Storage</Text>
                        </View>
                        <View style={styles.tableColBox2}>
                            <Text style={styles.textBox}>:</Text>
                        </View>
                        <View style={styles.tableCol3}>
                            <Text style={styles.textBox}>-</Text>
                        </View>
                    </View>
                    <View style={styles.tableRow}>
                        <View style={styles.tableColBox1}>
                            <Text style={styles.textEn}>Jenis Produk</Text>
                        </View>
                        <View style={styles.tableColBox2}>
                            <Text style={styles.textBox}>:</Text>
                        </View>
                        <View style={styles.tableCol3}>
                            <Text style={styles.textBox}>{ppmMutu ? (ppmMutu.mutuJnsProduk !== undefined && ppmMutu.mutuJnsProduk !== null ? <JenisProduk id={ppmMutu.mutuJnsProduk} /> : '') : ''}</Text>
                        </View>
                    </View>
                    <View style={styles.tableRow}>
                        <View style={styles.tableColBox1}>
                            <Text style={styles.textEn}>Temperatur</Text>
                        </View>
                        <View style={styles.tableColBox2}>
                            <Text style={styles.textBox}>:</Text>
                        </View>
                        <View style={styles.tableCol3}>
                            <Text style={styles.textBox}>{ppmMutu ? (<>{ppmMutu.mutuTemp} DERAJAT CELCIUS</>) : ''}</Text>
                        </View>
                    </View>
                    <View style={styles.tableRow}>
                        <View style={styles.tableColBox1}>
                            <Text style={styles.textEn}>Jenis Temperatur</Text>
                        </View>
                        <View style={styles.tableColBox2}>
                            <Text style={styles.textBox}>:</Text>
                        </View>
                        <View style={styles.tableCol3}>
                            <Text style={styles.textBox}>{ppmMutu ? (ppmMutu.mutuTempTipe !== undefined && ppmMutu.mutuJnsProduk !== null ? <TipeTemp id={ppmMutu.mutuTempTipe} /> : '') : ''}</Text>
                        </View>
                    </View>
                    <View style={styles.tableRow}>
                        <View style={styles.tableColBox1}>
                            <Text style={styles.textEn}>Processing Type</Text>
                        </View>
                        <View style={styles.tableColBox2}>
                            <Text style={styles.textBox}>:</Text>
                        </View>
                        <View style={styles.tableCol3}>
                            <Text style={styles.textBox}>{ppmMutu ? ppmMutu.mutuProses : ''}</Text>
                        </View>
                    </View>
                </View>
            </Page>
        </Document >
    )
}

export default DraftPermohonan